import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll(".theme-color").forEach((element) => {
      if (element.nextElementSibling?.tagName === "TABLE") return

      const color = getComputedStyle(element).backgroundColor
      const [red, green, blue] = color.match(/\d+/g).map(Number)
      const hex = `#${[red, green, blue].map((channel) => channel.toString(16).padStart(2, "0")).join("")}`
      const table = document.createElement("table")
      table.classList.add("w-100")
      table.innerHTML = `<tr><td class="text-body-secondary">HEX:</td><td class="fw-semibold">${hex}</td></tr><tr><td class="text-body-secondary">RGB:</td><td class="fw-semibold">${color}</td></tr>`
      element.after(table)
    })
  }
}
